import { useEffect } from "react";

export const useSandpackRun = (onRunCallback: () => void) => {
  useEffect(() => {
    const buttons = document.querySelectorAll(
      'button.sp-icon-standalone.sp-c-bxeRRt.sp-c-gMfcns.sp-c-dEbKhQ.sp-c-bcibQq.sp-button[type="button"]'
    );

    const myRunButton = document.querySelector("#myRunButton");

    const runButton = Array.from(buttons).find((button) => {
      const span = button.querySelector("span");
      const svgTitle = button.querySelector("svg title");
      return (
        span &&
        span.textContent?.trim() === "Run" &&
        svgTitle &&
        svgTitle.textContent?.trim() === "Run sandbox"
      );
    });

    const handleButtonClick = () => {
      onRunCallback();
    };

    myRunButton?.addEventListener("click", handleButtonClick);

    if (runButton && runButton instanceof HTMLElement) {
      // console.log("run button: ", runButton);
      runButton.addEventListener("click", handleButtonClick);
    }

    return () => {
      myRunButton?.removeEventListener("click", handleButtonClick);
      if (runButton && runButton instanceof HTMLElement) {
        runButton.removeEventListener("click", handleButtonClick);
      }
    };
  }, [onRunCallback]);
};
